import { VideoEmbedTokenResponse } from "@videos/models/embedToken";

export const buildBrightcovePlayerIframeSrc = (embedToken: VideoEmbedTokenResponse | null): string | null => {
  if (!embedToken) {
    return null;
  }

  const params = new URLSearchParams({
    accountId: embedToken.accountId,
    playerId: embedToken.playerId,
    videoId: embedToken.videoId,
    token: embedToken.token,
  });

  return `${process.env.PUBLIC_URL ?? ""}/brightcove-player.html?${params.toString()}`;
};
